import {useContext} from 'react'

import { ShowUserModalFormWrapper } from './ShowUserModalFormWrapper'
import { ShowUserModalHeader } from './ShowUserModalHeader'
import { PartnerContext } from '../PartnerContexts'

const ShowUserModal = () => {

  const {showSelectUserModal} = useContext(PartnerContext)

  return (
    <>
      {showSelectUserModal && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-xl'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <ShowUserModalHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <ShowUserModalFormWrapper />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {ShowUserModal}
